import script from "./DocsMDComp.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsMDComp.vue?vue&type=script&setup=true&lang=js"

import "./DocsMDComp.vue?vue&type=style&index=0&id=00a8d484&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a8d484"]])

export default __exports__